import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useRedirectToCV1 } from "@/features/licensing/components/redirect-to-cv1";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export function VidyoLayout() {
  const initializeVidyo = useVidyoStore((state) => state.initializeVidyo);
  useRedirectToCV1();

  useEffect(() => {
    initializeVidyo();
  }, []);
  return <Outlet />;
}
